// extracted by mini-css-extract-plugin
module.exports = {"normal":"Index_normal__3ZHzX","normalH5":"Index_normalH5__2Kig8","animationFade":"Index_animationFade__25ANp"};